module.exports = __webpack_public_path__ + "img/user-channels.86a0e2bd.png";